export enum FilterLoadState {
  NOT_LOADED = 0,
  LOADING = 1,
  FINISHED_LOADING = 2,
}
